export default __webpack_public_path__ + "static/media/Head_5_Ear_2_C4.5a8ec992.svg";